/* eslint-disable */

import { combineReducers } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import offerDetails from '../features/offerSearch/offerSearchSlice';
import siteContent from '../features/siteContent/siteContentSlice';
import newOfferPaymentDetails from '../features/OfferPaymentContainer/OfferPaymentSlice';
import PinOptFlowDetails from '../features/OfferValidateContainer/PinOptFlowOfferSlice'

const offerDetailPersistConfig = {
  key: 'offerDetails',
  storage: storage,
  blacklist: [
    'hasError',
    'showProspect',
    'currentNavigationStep',
    'loading',
    'searchMode',
    'error',
    'showCTA',
    'isPackageSold',
  ],
};


const newOfferPaymentPersistConfig = {
  key: 'offerDetails',
  storage: storage,
  blacklist: ['billingDetailInfo', 'BillingDetailErr', 'pageLoadTime', 'isPaymentCheckBox', 'isFLexFormValid'],
};
const pinFlowOptDetailPersistConfig = {
  key: 'pinOptFlowDetails',
  storage: storage,
  blacklist: ['error']
}
const offerDetailsReducer = persistReducer(offerDetailPersistConfig, offerDetails);
const newOfferPaymentReducer = persistReducer(newOfferPaymentPersistConfig, newOfferPaymentDetails);
const pinOptFlowDetailsReducer = persistReducer(pinFlowOptDetailPersistConfig, PinOptFlowDetails)
const rootReducer = combineReducers({
  siteContent,
  offerDetails: offerDetailsReducer,
  newOfferPaymentDetails: newOfferPaymentReducer,
  pinOptFlowDetails: pinOptFlowDetailsReducer,
});
//export type RootState = ReturnType<typeof store.getState>;
export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
